import React, { useState } from 'react';
import { Shield, MessageCircle, Twitter, Linkedin, Instagram } from 'lucide-react';
import PrivacyPolicy from './Land/Footer/PrivacyPolicy';
import TermsOfServiceModal from './Land/Footer/TermsOfService';
import SecurityModal from './Land/Footer/securityTerm'; 

const PremiumButton = ({ children, variant = 'primary', className = '', ...props }) => {
    const variants = {
        primary: 'bg-gradient-to-r from-blue-600 to-purple-700 hover:from-blue-700 hover:to-purple-800 text-white',
        secondary: 'bg-gray-800 border border-gray-700 hover:bg-gray-700 text-gray-200',
        outline: 'border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white',
    };

    return (
        <button 
            className={`
                px-6 py-3 rounded-lg transition-all duration-300 
                flex items-center justify-center space-x-2
                font-semibold text-sm uppercase tracking-wider
                ${variants[variant]}
                ${className}
            `}
            {...props}
        >
            {children}
        </button>
    );
};

const Footer = () => {
    const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);
    const [termsOfServiceModalOpen, setTermsOfServiceModalOpen] = useState(false);
    const [securityModalOpen, setSecurityModalOpen] = useState(false);
    const currentYear = new Date().getFullYear();

    const socialLinks = [
      { 
        icon: Twitter, 
        link: "https://x.com/0X10LayerFF?t=aJ36mJOzE2ymNUd9LBpokg&s=08", 
        color: "text-blue-400 hover:text-blue-300" 
      },
      { 
        icon: Linkedin, 
        link: "https://linkedin.com/company/0x10layerff", 
        color: "text-blue-600 hover:text-blue-500" 
      },    
      { 
        icon: Instagram, 
        link: "https://www.instagram.com/0x10.layerff?igsh=dXU4NmJyMjFtdzI4&utm_source=qr", 
        color: "text-pink-500 hover:text-pink-400" 
      }
    ];

    return (
        <>
            <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-8">
            <div>
            <h4 className="text-xl font-bold mb-4 flex items-center">
              <Shield className="w-6 h-6 mr-2 text-blue-500" /> 0X10LayerFF Pro
            </h4>
            <p className="text-gray-400 mb-4">Advanced cybersecurity solutions for modern enterprises.</p>
            <div className="flex space-x-3">
              {socialLinks.map((social, index) => (
                <a 
                  key={index} 
                  href={social.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={`${social.color} transition-all duration-300 hover:scale-110`}
                >
                  <social.icon className="w-6 h-6" />
                </a>
              ))}
            </div>
            </div>
                
                <div>
                    <h5 className="font-semibold mb-4">Quick Links</h5>
                    <ul className="space-y-2">
                        <li><a href="#features" className="hover:text-blue-400">Features</a></li>
                        <li><a href="#pricing" className="hover:text-blue-400">Pricing</a></li>            
                        <li><a href="#contact" className="hover:text-blue-400">Support</a></li>
                    </ul>
                </div>
                
                <div>
                    <h5 className="font-semibold mb-4">Legal</h5>
                    <ul className="space-y-2">
                        <li>
                            <button 
                                onClick={() => setPrivacyPolicyModalOpen(true)} 
                                className="hover:text-blue-400"
                            >
                                Privacy Policy
                            </button>
                        </li>
                        <li>
                            <button 
                                onClick={() => setTermsOfServiceModalOpen(true)} 
                                className="hover:text-blue-400"
                            >
                                Terms of Service
                            </button>
                        </li>
                        <li>
                            <button 
                                onClick={() => setSecurityModalOpen(true)} 
                                className="hover:text-blue-400"
                            >
                                Security Terms
                            </button>
                        </li>
                    </ul>
                </div>
                
                <div>
                    <h5 className="font-semibold mb-4">Contact Us</h5>
                    <p className="text-gray-400 mb-4">Get in touch for custom solutions</p>
                    <PremiumButton variant="secondary">
                        <MessageCircle className="w-5 h-5" /> Start Conversation
                    </PremiumButton>
                </div>
            </div>
            
            <div className="text-center mt-8 text-gray-500 border-t border-gray-800 pt-6">
                <p>
                    © {currentYear} 0X10LayerFF Pro. All Rights Reserved.
                </p>
                <p className="text-xs text-gray-600 mt-2">
                    Developed with 💻 by 
                    <span className="ml-2 font-semibold text-blue-400">
                        F/N Nuru The Geek Collective
                    </span>
                </p>
            </div>

            {/* Conditionally render the modals based on their state */}
            <PrivacyPolicy 
                privacyPolicyModalOpen={privacyPolicyModalOpen} 
                setPrivacyPolicyModalOpen={setPrivacyPolicyModalOpen} 
            />
            <TermsOfServiceModal 
                termsOfServiceModalOpen={termsOfServiceModalOpen} 
                setTermsOfServiceModalOpen={setTermsOfServiceModalOpen} 
            />
            <SecurityModal 
                securityModalOpen={securityModalOpen} 
                setSecurityModalOpen={setSecurityModalOpen} 
            />
        </>
    );
};

export default Footer;